module.exports = __webpack_public_path__ + "static/media/kpg-accountants-logo.deabebb5.jpg";